// =============================================================================
// Back-office: marcas a revisión
// =============================================================================
//
// `PENDING_APPROVAL` se escribe en CUATRO sitios —geovalla dudosa online,
// fichaje de más de 48 h atrás, centro que no resuelve, QR fallido offline— y
// una marca a revisión NO cuenta para el cálculo del día. Los endpoints
// existían desde el 23/08/2026 y no los llamaba nadie: la cola era invisible
// para el responsable, así que una jornada trabajada de verdad se imprimía
// AUSENTE en el informe del art. 34.9 y descontaba de la bolsa —
// indefinidamente, porque nadie sabía que había algo que revisar.
import { apiClient } from './http';

/** Una marca del mismo trabajador posterior a la pendiente (contexto de decisión). */
export interface MarcaPosterior {
  type: string;
  server_timestamp: string;
  status: string;
}

export interface PendingPunch {
  id: number;
  user_id: number;
  user_name: string;
  type: 'IN' | 'OUT' | 'BREAK_START' | 'BREAK_END';
  server_timestamp: string;
  client_timestamp: string | null;
  worksite_id: number | null;
  worksite_name: string | null;
  source: string;
  // Hasta 10 marcas del mismo usuario POSTERIORES a la pendiente: es el
  // contexto con el que el 409 de resolve le dice al responsable que decida
  // («el trabajador volvió a fichar alrededor de esta marca…»). El backend
  // las calculaba desde la ronda 3 y aquí no las pintaba nadie (r2b20[3]).
  marcas_posteriores: MarcaPosterior[];
  // Por qué la marca acabó a revisión: BACKDATED, PRL_BLOCKED, *_GEOFENCE,
  // códigos de transición… Código crudo del backend; null = sin motivo
  // registrado (r2b02[2], mitad frontend).
  review_reason: string | null;
}

export async function getPendingPunches(): Promise<PendingPunch[]> {
  const res = await apiClient.get<PendingPunch[]>('/punch/pending');
  return res.data;
}

export async function resolvePendingPunch(
  id: number,
  approved: boolean,
  reason?: string,
): Promise<void> {
  await apiClient.post(`/punch/pending/${id}/resolve`, null, {
    params: { approved, ...(reason ? { reason } : {}) },
  });
}
